import React from 'react'
import "./Order.css"
import { useNavigate } from 'react-router-dom';
const Order = () => {
   const navigate = useNavigate();
  return (
    <><div className="order">
    <div className="order-section">
      <div className="order-section__column">
        <div className="order-section__booking">
          <img src="" alt="Bookingone" className="order-section__image" />
          <div className="order-section__confirmation">
            <h1 className="order-section__title ui heading size-headingxl">
              Order Confirmed
            </h1>
            <p className="order-section__description ui text size-text2xl">
              Your order is confirmed. You will receive an order confirmation
              email/SMS shortly with the expected delivery date for your items.
            </p>
          </div>
        </div>
        <div className="order-section__details">
          <div className="order-section__pricing">
            <h2 className="order-section__customer-info ui heading size-headingmd">
              Rayandip Biswas | 9832140247
            </h2>
            <p className="order-section__address ui text size-text2xl">
              Charaktala, Near Shiv Mondir, Bangaon (North 24 Parganas), Bongaon
              West Bengal - 743235{" "}
            </p>
          </div>
          <button className="flex-row-center-center order-section__button ui button deep_orange_700_01 size-sm outline round">
            <span>ORDER DETAILS</span>
            <img src="" alt="Arrow Right" className="arrow_right" />
          </button>
        </div>
      </div>
    </div>
  </div>
  </>
  )
}

export default Order